export default {"src":"/_next/static/media/logo-en.6800a575.svg","height":120,"width":170,"blurWidth":0,"blurHeight":0};